import { call, put, takeLatest, select } from 'redux-saga/effects';
import { delay } from 'redux-saga'
import { slugify } from "../helpers/general.helper";

import {
    GET_ALL_NEWS,
    GET_LAST_NEWS,
    GET_LAST_NEWS_FROM_ALL_CATEGORIES,
    GET_NEWS_DETAILS,
    GET_FAVORITE_NEWS,
    ADD_NEWS_TO_FAVORITE,
    ADD_NEWS_COMMENT,
    REMOVE_NEWS_FROM_FAVORITE,
    GET_SLIDER_NEWS,
    GET_NEWS_FROM_CATEGORY,
    GET_NEWS_FROM_CATEGORY_SEE_MORE,
    GET_RECOMMENDED_NEWS, GET_NEWS_CATEGORIES
} from "../actions/types";
import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import { GENERIC_ERROR_MESSAGE, COMMENT_ADDED} from "../config/messages";
import {
    getAllNews,
    getSliderNews,
    getLastNews,
    getLastNewsFromAllCategories,
    getNewsDetails,
    getFavoriteNews,
    addNewsToFavorite,
    addNewsComment,
    removeNewsFromFavorite,
    getNewsFromCategory,
    getRecommendedNews,
    getNewsCategories
} from "../api/news.api";
import {
    getAllNewsSucceeded,
    getSliderNewsSucceeded,
    getLastNewsFromAllCategoriesSucceeded,
    getLastNewsSucceeded,
    getFavoriteNewsSucceeded,
    getNewsDetailsSucceeded,
    getNewsFromCategorySucceeded,
    getNewsFromCategorySeeMoreSucceeded,
    getRecommendedNewsSucceeded, getNewsCategoriesSucceeded,
} from "../actions/news.actions";
import {reset} from 'redux-form';
import {showSpinner, hideSpinner} from '../actions/loading.actions';
import { getNewsCategory } from '../api/filters.api';
import {push} from "connected-react-router";
import {NOT_FOUND_ROUTE} from "../config/routes";


function* getAllNewsSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getAllNews, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200) {
            yield put(getAllNewsSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getSliderNewsSaga(action) {
    try {
        const response = yield call(getSliderNews, action.payload);
        if(response.status === 200) {
            yield put(getSliderNewsSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}


function* getLastNewsSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getLastNews, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200) {
            yield put(getLastNewsSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getLastNewsFromAllCategoriesSaga(action) {
    try { 
        yield put(showSpinner());
        const response = yield call(getLastNewsFromAllCategories, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200) {
            yield put(getLastNewsFromAllCategoriesSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getNewsDetailsSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getNewsDetails ,action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200) {
            yield put(getNewsDetailsSucceeded(response.data));
        }
    } catch(e) {
        if( e.message.substr(e.message.length - 3) === '404') {
            yield put(push(NOT_FOUND_ROUTE));
        } else {
            yield put(hideSpinner());
            yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        }
    }  
}

function* getFavoriteNewsSaga(action){
    try {
        yield put(showSpinner());
        const response = yield call(getFavoriteNews, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200) {
            yield put(getFavoriteNewsSucceeded(response.data));
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }  
}

function* addNewsToFavoriteSaga(action) {
    try{
        yield put(showSpinner());
        const response = yield call(addNewsToFavorite, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if(response.status === 201) {
            const prevState = yield select(state => state.news.newsDetails);
            const favNews = {...prevState, favorite:[{uuid: response.data.data.id}]}
            yield put(getNewsDetailsSucceeded(favNews));
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addNewsCommentSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(addNewsComment, action.payload);
        if (response.status === 200){ 
            yield put(hideSpinner());
            yield put(showSpinner());
            const newsDetailsResponse = yield call(getNewsDetails ,action.payload.article_id);
            if(newsDetailsResponse.status === 200) {
                yield put(hideSpinner());
                yield put(getNewsDetailsSucceeded(newsDetailsResponse.data));
            }
            yield put(reset('addCommentForm'));
            yield put(showGeneralError(COMMENT_ADDED));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeNewsFromFavoriteSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(removeNewsFromFavorite, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if (response.status === 204){
            const prevState = yield select(state => state.news.newsDetails);
            const favMovie = {...prevState, favorite:[]}
            yield put(getNewsDetailsSucceeded(favMovie));
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getNewsFromCategorySaga(action){


    try{
        yield put(showSpinner());
        const newsCategory = yield call(getNewsCategory, action.payload.newsCategory);
        let newsCategoryId = newsCategory.data.find(item => slugify(item.name) === slugify(action.payload.newsCategory)).id;
        let response = yield call(getNewsFromCategory, {id: newsCategoryId, page: action.payload.page});

        if(response.status === 200){
            yield put(hideSpinner())
            yield put(getNewsFromCategorySucceeded(response.data));
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getNewsFromCategorySeeMoreSaga(action){
    try{
        yield put(showSpinner());
        const newsCategory = yield call(getNewsCategory, action.payload.newsCategory);
        let newsCategoryId = newsCategory.data.find(item => slugify(item.name) === slugify(action.payload.newsCategory)).id;
        let response = yield call(getNewsFromCategory, {id: newsCategoryId, page: action.payload.page})
       
        if(response.status === 200){
            yield put(hideSpinner());
            const prevState = yield select(state => state.news.newsCateg);
            if(prevState.rows){
                const news = {...prevState, rows: prevState.rows.concat(response.data.rows), pager: response.data.pager}
                yield put(getNewsFromCategorySeeMoreSucceeded(news))
            }
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getRecommendedNewsSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getRecommendedNews, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200) {
            yield put(getRecommendedNewsSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function *getNewsCategoriesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getNewsCategories, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200) {
            yield put(getNewsCategoriesSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

export default function* newsSaga() {
    yield takeLatest(GET_ALL_NEWS, getAllNewsSaga);
    yield takeLatest(GET_SLIDER_NEWS, getSliderNewsSaga);
    yield takeLatest(GET_LAST_NEWS, getLastNewsSaga);
    yield takeLatest(GET_LAST_NEWS_FROM_ALL_CATEGORIES, getLastNewsFromAllCategoriesSaga);
    yield takeLatest(GET_NEWS_DETAILS, getNewsDetailsSaga);
    yield takeLatest(GET_FAVORITE_NEWS, getFavoriteNewsSaga);
    yield takeLatest(ADD_NEWS_TO_FAVORITE, addNewsToFavoriteSaga);
    yield takeLatest(ADD_NEWS_COMMENT, addNewsCommentSaga);
    yield takeLatest(REMOVE_NEWS_FROM_FAVORITE, removeNewsFromFavoriteSaga);
    yield takeLatest(GET_NEWS_FROM_CATEGORY, getNewsFromCategorySaga);
    yield takeLatest(GET_NEWS_FROM_CATEGORY_SEE_MORE, getNewsFromCategorySeeMoreSaga);
    yield takeLatest(GET_RECOMMENDED_NEWS, getRecommendedNewsSaga);
    yield takeLatest(GET_NEWS_CATEGORIES, getNewsCategoriesSaga);
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/news.saga.js